import { createContext, useContext } from 'react';
export const DocumentContext = createContext({
    document: null,
});
export const useDocument = () => useContext(DocumentContext);
//# sourceMappingURL=useDocument.js.map